import {
    SetPortfolioMessagePayload,
    setPortfolioMessagePayloadSchema,
} from 'embedded/api/in/messages/SetPortfolioMessagePayload';
import { InMessageTopic } from 'embedded/api/in/InMessageTopic';
import { AnyAction, Store } from 'redux';
import { LoggingService } from '@instinet-analytics/core-lib';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import { setEmbeddedPortfolioActionAsync } from 'embedded/store/thunks';
import { ThunkDispatch } from 'store/store';

export class SetPortfolioMessage extends InMessageTopic<SetPortfolioMessagePayload> {
    public constructor() {
        super(setPortfolioMessagePayloadSchema);
    }

    public handle(
        uid: string,
        payload: SetPortfolioMessagePayload,
        store: Store,
        _loggingService: LoggingService
    ): void {
        const symbology: SymbologyValues =
            payload.symbology ?? SymbologyValues.Instinet;

        const positions: PortfolioPosition[] = payload.positions.map((p) => {
            const { symbol, qty: payloadQty, side: payloadSide } = p;
            const qty = payloadQty === undefined ? 1 : payloadQty;
            const absQty = Math.abs(qty);
            const side = payloadSide ? payloadSide : qty >= 0 ? 'B' : 'S';

            return {
                symbol,
                qty: absQty,
                side,
                qtyRemaining: absQty,
            };
        });

        const { orderIds } = payload;

        const dispatch = store.dispatch as ThunkDispatch<AnyAction>;
        dispatch(
            setEmbeddedPortfolioActionAsync({
                symbology,
                positions,
                orderIds: orderIds ?? [],
            })
        );
    }
}
